import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBevel = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7 11.7V15H4V9.5L9.5 4H15v3h-3.3L7 11.7z"
	})
});
export default SvgBevel;
